import { createField } from "./send-sampling-info.section";
import lodash from "lodash";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    data.fields = createField({ props, data, refs, key, isLoading });

    if (model.id) {
        data.products = {
            fetchCriteria: {
                select: ["**",
                    "refSampling.refReleaseProduct.refRelease.refInspection.approveCode",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHazObject.nameTh",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.tradeNameTh",
                    "refSampling.refReleaseProduct.refInspectionProduct.refInformProduct.refHaz.refSubStanceTypeMain.value",
                    "refSampling.refSizeUnit.value",
                    "refSampling.refQtyUnit.value",
                ],
                page: 0,
                size: 1000000,
                where: [{ name: "refSendSampling.id", type: "UUID", operator: "=", value: model.id }],
                sort: [{ name: "createDate", type: "ASC" }]
            }
        };
    }
};

export const createForm = () => {
    const form = {
        refDepartment: null,
        refUserCompany: null,
        refUser: null,
        approveCode: null,
        effectiveDate: null,
        expireDate: null,
        refStatus: null,
        products: []
    };
    return form;
};